import {Component} from '@angular/core';
import {SettingsIncidentReportService} from '../../../services/settings-incident-report.service';

declare const toastr: any;

@Component({
    selector: 'detailed-view',
    templateUrl: './detailed-view.component.html',
    styleUrls: ['./detailed-view.component.scss']
})
export class DetailedViewComponent {
    currentTab = 'general';
    disabledDelete = false;

    constructor(public settingsIncidentReportService: SettingsIncidentReportService) {}

    setTab(tabName: string) {
        this.currentTab = tabName;
    }

    showNotificationModal(staffOrResident, notificationType): void {
        this.settingsIncidentReportService.isNotificationModalShow = true;
        this.settingsIncidentReportService.notificationModalStaffOrResident = staffOrResident;
        this.settingsIncidentReportService.notificationModalNotificationType = notificationType;
    }

    emailTemplateIsSet(type, action) {
        let flag = false;
        if(this.settingsIncidentReportService.selectedItemData[type + 'NotificationSettings']) {
            this.settingsIncidentReportService.selectedItemData[type + 'NotificationSettings'].forEach((setting) => {
                if (setting.action == action)
                    flag = setting.template === null && !setting.message && !setting.subject ? false : true;
            });
        }
        return flag;
    }

    submitNotificationsField(): void {
        const data = {
            staffNotificationSettings : [
                {
                    action: 'report_created',
                    active: this.settingsIncidentReportService.requestCreatedStaffCheckbox ? true : false,
                    roles:  this.getUserRolesFormatted(this.settingsIncidentReportService.createdStaffMultiselectArray)
                },
                {
                    action: 'report_updated',
                    active: this.settingsIncidentReportService.requestModifiedStaffCheckbox ? true : false,
                    roles:  this.getUserRolesFormatted(this.settingsIncidentReportService.modifiedStaffMultiselectArray)
                },
                {
                    action: 'report_deleted',
                    active: this.settingsIncidentReportService.requestDeletedStaffCheckbox ? true : false,
                    roles:  this.getUserRolesFormatted(this.settingsIncidentReportService.deletedStaffMultiselectArray)
                }
            ]
        };
        this.onSubmit(data);
    }

    getUserRolesFormatted(arr): Array<any> {
        return arr.map(a => ({bdId: a.id, name: a.itemName}));
    }

    onSubmit(data: any): void {
        const url = `/v1/settings/${this.settingsIncidentReportService.selectedItemData.id}.json`;
        this.settingsIncidentReportService.api.patch('domainIncidentReports', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            error => this.settingsIncidentReportService.api.errorHandler(error, 'Update failed!')
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        this.settingsIncidentReportService.getData();
    }

    submitBuildings(buildings) {
        const data = {
            buildings: buildings.map(b => ({
                           bdId: b.id,
                           name: b.itemName
                       }))
        };
        this.onSubmit(data);
    }

    deleteSetting() {
        this.disabledDelete = true;
        const url = `/v1/settings/${this.settingsIncidentReportService.selectedItemData.id}.json?`;
        this.settingsIncidentReportService.api.remove('domainIncidentReports', url).subscribe(
            res => this.updateView('Setting has been deleted successfully'),
            error => {
                this.disabledDelete = false;
                this.settingsIncidentReportService.api.errorHandler(error, 'Failed to delete.');
            }
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-incident-report/detailed-view/detailed-view.component.ts